import { Component, EventEmitter, Input, Output } from '@angular/core';
import { appSettings } from 'app/appSettings';
import { StockCountSandbox } from 'app/core/sandboxes/stock-count.sandbox';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { AuthorizationMatrix } from 'app/core/store/session/authorization/authorization.interface';
import { StockCountFilter } from 'app/core/store/stock-count/stock-count-filter.interface';
import { ContractRestrictions } from '../../../core/store/contract-details/contract-details.interface';
import { util } from '../../../core/util/util';

@Component({
  selector: 'app-stock-count-list',
  templateUrl: './stock-count-list.component.html',
  styleUrls: ['../../florders/florder-list/florder-list.scss', './stock-count-list.component.scss'],
})
export class StockCountListComponent {
  dateFormat: string = appSettings.DATE_FORMAT_ANGULAR;

  sortField: string;
  sortAscending: boolean = true;

  @Input() stockCounts: any;
  @Input() isLoading: boolean;
  @Input() isDownloading: boolean;
  @Input() authorization: AuthorizationMatrix;
  @Input() restrictions: ContractRestrictions;
  @Input() filter: StockCountFilter;
  @Input() totalItems: number;
  @Input() shipTos: Definition[];

  @Output() openStockCount = new EventEmitter();

  constructor(private sandbox: StockCountSandbox) {}

  onPageChange(pageNumber: number) {
    if (pageNumber) {
      this.sandbox.filterStockCounts({
        value: {
          pageNumber,
        },
        valid: true,
      });
    }
  }

  itemsPerPageChange(pageSize: string) {
    const pageSizeNumber = util.toNumber(pageSize);
    this.filter.pageSize = pageSizeNumber;
    if (pageSizeNumber) {
      this.sandbox.filterStockCounts({
        value: {
          pageSize: pageSizeNumber,
        },
        valid: true,
      });
    }
  }

  sortingChange() {
    this.sandbox.filterStockCounts({
      value: {
        sortingColumn: this.sortField,
        sortingType: this.sortAscending ? 'asc' : 'desc',
      },
      valid: true,
    });
  }

  sort(field: string) {
    if (this.sortField === field) {
      this.sortAscending = !this.sortAscending;
      this.sortingChange();
    } else {
      this.sortField = field;
      this.sortingChange();
      if (!this.sortAscending) {
        this.sortAscending = true;
        this.sortingChange();
      }
    }
  }

  sortBnd = this.sort.bind(this);

  mapShipTos(id: string) {
    if (id && this.shipTos) {
      const shipto = this.shipTos.find(shipto => util.toNumber(shipto.id) === util.toNumber(id));
      return shipto && shipto.name ? shipto.name : '';
    } else {
      return '';
    }
  }
}
